import Menu from "ant-design-vue/es/menu"
import Icon from "ant-design-vue/es/icon"
import Avatar from "ant-design-vue/es/avatar"

import customizedIcons from "@/util/icons"

const { Item, SubMenu } = Menu

export default {
  name: "test",
  props: {
    menu: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    }
  },
  methods: {
    renderAvatar: function (h, avatar) {
      if (avatar == null || avatar == undefined) 
        return null
      let src = this.$store.getters[avatar.store]();
      if (avatar.store && src) {
        return h(
          Avatar,
          {
            props: {
              size: 14,
              src: src
            },
            style: {
              marginLeft: "4px"
            }
          }
        );
      } else {
        return h(
          Avatar,
          {
            props: {
              size: 14,
              icon: avatar.icon
            },
            style: {
              marginLeft: "4px"
            }
          }
        )
      }
    },
    renderIcon: function (h, icon) {
      if (icon == null || icon == undefined) 
        return null; 

      if (customizedIcons[icon]) 
        return h("span", {style: { paddingRight: "8px"} }, [h(customizedIcons[icon])]); 

      return h(Icon, { props: { type: icon } })
    },
    renderMenus: function (h, menus, type) {
      let menuArr = [];
      let that = this;
      menus.forEach(function(item, i) {
        if (item.meta.show && item.permission[type]) {
          menuArr.push(that.renderMenuItem(h, item, type));
        }
      });
      return menuArr;
    },

    renderMenuItem: function (h, item, type) {
       
      if (item.meta.store) {
        item.meta.title = this.$store.getters[item.meta.store]();
      }

      //console.log("renderMenuItem:"); 
      //console.log(item.meta); 
      //console.log(item.meta.store); 
      //console.log(item.meta.title); 

      if (item.children) {
        let subItem = [h("span", { slot: "title"}, [h("span", {style: { fontWeight: "600"}}, [item.meta.title]), this.renderAvatar(h, item.avatar)])];
        let itemArr = []
        let that = this;
        item.children.forEach(function (subMenu, i) {
          if (subMenu.meta.show && subMenu.permission[type] == true){
            itemArr.push(that.renderMenuItem(h, subMenu, type))
          }
        })
        return h(
          SubMenu, 
          { 
            key: "sub",
            style: {
              "float": item.meta.float
            }
          }, 
          subItem.concat(itemArr)
        )
      } else {
        //console.log("item.name:" + item.name); 
        //console.log("item.path:" + item.path);
        return h(
          Item, 
          { 
            key: item.name,
            //class: item.name == currentItemName ? "ant-menu-item-selected" : "",
            style: {
              padding: "0px 8px",
              margin: "0px"
            }
          }, 
          [
            h(
              "router-link", 
              { 
                attrs: {
                  to:  item.path
                } 
              },
              [ 
                this.renderIcon(h, item.meta.icon, item.meta.src),
                h("span", [item.meta.title])
              ]
            )
          ]
        )
      }
    }
  },
  render: function (h) {
    let user_type = this.$store.getters.getUsertype();
    var tab = this.$store.getters['getTab'](); 
    if (!tab) {
      tab = "";
    }

    //console.log("currentItemName: " + tab); 
    //console.log("user_type:" + user_type);

    return h(
      Menu,
      {
        props: {
          mode: "horizontal",
          defaultSelectedKeys: tab.split(","),
          selectedKeys: tab.split(",")
        },
        style: {
          textAlign: "left",
          background: "rgba(245, 246, 245, 1)"
        }
      },
      this.renderMenus(h, this.menu, user_type)
    )
   }
}
